import React, { useEffect, useState } from "react";
import ApiHelper from "../../helper/api-helper";
import ApiUrls from "../../helper/api-urls";
import { NotificationManager } from "src/util/notify";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import InputKendoRct from "../../control-components/input/input";
import Loader from "../../control-components/loader/loader";
import ErrorHelper from "../../helper/error-helper";
import { Button, Modal } from 'react-bootstrap';
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Encrption } from "../encrption";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const DataImport = () => {
    const [loading, setLoading] = useState(false);
    const [validateError, setValidateError] = useState(false);
    const [region, setRegion] = useState([]);
    const [clinic, setClinic] = useState([]);
    const [staff, setStaff] = useState([]);
    const [queueData, setQueueData] = useState([]);
    const [errors, setErrors] = useState("");
    const [fields, setFields] = useState({
        regionId: "",
        clinicId: "",
        staffId: "",
        s3FilePath: "",
        regionQueueId: "",
    });
    const [show, setShow] = useState(false);
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [sort, setSort] = useState([]);
    const [selectedRegionId, setSelectedRegionId] = useState(null);
    const [selectedState, setSelectedState] = React.useState({});


    useEffect(() => {
        getRegion();
    }, []);

    const handleClose = () => {
        setShow(false);
        setFields({
            regionId: "",
            clinicId: "",
            staffId: "",
            s3FilePath: "",
            regionQueueId: "",
        })
        setClinic([]);
        setStaff([]);
    }

    const handleShow = () => {
        setShow(true);
    };

    const getRegion = async () => {
        setLoading(true);
        ApiHelper.getRequest(ApiUrls.GET_REGIONS)
            .then((result) => {
                setLoading(false);
                let data = result.resultData;
                setRegion(data);
            })
            .catch((error) => {
                NotificationManager.error(error.message);
            });
    };

    const getClinic = async (region) => {
        setLoading(true);


        ApiHelper.getRequest(ApiUrls.GET_CLINIC_BY_REGION + "region=" + Encrption(region.id) + "&isActive=true")
            .then((result) => {
                setLoading(false);
                let data = result.resultData;
                setClinic(data);
            })
            .catch((error) => {
                NotificationManager.error(error.message);
            });
    };

    const getStaff = async (value) => {
        setLoading(true);
        const data = {
            masterClinicId: value,
            staffId: 0,
            userName: "",
            email: "",
            firstName: "",
            lastName: "",
            region: ""

        };
        ApiHelper.postRequest(ApiUrls.GET_STAFF, data)
            .then((result) => {
                setLoading(false);
                let data = result.resultData.filter(x => x.isActive);
                setStaff(data);
            })
            .catch((error) => {
                NotificationManager.error(error.message);
            });
    };

    const getQueueData = async (value) => {
        setLoading(true);
        ApiHelper.getRequest(ApiUrls.GET_ALL_DATA_IMPORT_QUEUE_ITEMS + value)
            .then((result) => {
                setLoading(false);
                let data = result.resultData;
                setQueueData(data);
            })
            .catch((error) => {
                setLoading(false);
                NotificationManager.error(error.message);
            });
    }

    const handleAddQueue = () => {
        setLoading(true);
        if (handleValidation()) {
            const data = {
                region: fields.regionId.id,
                s3PathPrefix: "imported data/" + fields.s3FilePath,
                clinicId: fields.clinicId.masterClinicId,
                staffId: fields.staffId.staffId
            };

            ApiHelper.postRequest(ApiUrls.ADD_IMPORT_REQUEST, data)
                .then((result) => {
                    handleClose();
                    setLoading(false);
                    console.log(result);
                    NotificationManager.success("New data import added to queue");
                })
                .catch((error) => {
                    setLoading(false);
                    NotificationManager.error(error.message);
                });

        }
        setLoading(false);
    }

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;
        if (!fields.regionId || fields.regionId.id === null) {
            formIsValid = false;
            errors["regionId"] = ErrorHelper.REGION;
        }
        if (!fields.clinicId || fields.clinicId.id === null) {
            formIsValid = false;
            errors["clinicId"] = ErrorHelper.CLINIC_ID;
        }
        if (!fields.staffId || fields.staffId.staffId === null) {
            formIsValid = false;
            errors["staffId"] = ErrorHelper.STAFF_ID;
        }
        if (!fields.s3FilePath || fields.s3FilePath.trim() === '') {
            formIsValid = false;
            errors["s3FilePath"] = ErrorHelper.S3_FILE_PATH;
        }
        setErrors(errors);
        return formIsValid;
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === "regionId") {
            setFields({ ...fields, regionId: value, clinicId: "", staffId: "" });
            if (value) {
                getClinic(value);
            }
            else {
                setClinic([]);
                setStaff([]);
            }
        }
        if (name === "regionQueueId") {
            setSelectedRegionId(value);
            if (value && value.id) {
                getQueueData(value.id);
            }
        }
        if (name === "clinicId") {
            setFields({ ...fields, clinicId: value, staffId: "" });
            if (value && value.id) {
                getStaff(value.id);
            }
            else {
                setStaff([]);
            }
        }
        if (name === "staffId") {
            setFields({ ...fields, staffId: value });
        }
        if (name === "s3FilePath") {
            setFields({ ...fields, s3FilePath: value });
        }
    };

    const pageChange = (event) => {
        let skip = event.page.skip;
        let take = event.page.take;
        setPage(skip);
        setPageSize(take);
    };

    const requeueFile = props => {
        ApiHelper.postRequest(ApiUrls.ADD_IMPORT_FILE_REQUEST, { fileId: props.id, region: fields.regionQueueId.id })
            .then((result) => {
                handleClose();
                setLoading(false);
                NotificationManager.success("Requeued");
            })
            .catch((error) => {
                setLoading(false);
                NotificationManager.error(error.message);
            });
    }
    return (
        <>

            <div className="d-flex flex-wrap">
                <div className="col-12">
                    <div className="d-flex justify-content-between  mt-3">
                        <h4 className="address-title text-grey ">
                            <span className="f-24">Data Import</span>
                        </h4>
                    </div>
                    <div className="d-flex justify-content-between align-items-center edit-Service-popup">
                        <DropDownKendoRct
                            label="Region"
                            onChange={handleChange}
                            data={region}
                            value={selectedRegionId}
                            textField="regionName"
                            name="regionQueueId"
                        />
                        <Button variant="primary" onClick={handleShow}>
                            <span class="fa fa-plus" style={{ color: "#fff" }}></span> Add Data Import
                        </Button>
                    </div>
                    {
                        loading === true ? <Loader /> : <div className="grid-table  filter-grid">
                            <div className=" mt-3">
                                <div className="inner-section-edit position-relative text-center">
                                    <div className="grid-table  filter-grid header-blue">
                                        <div className=" mt-3">
                                            <Grid
                                                data={orderBy(queueData.slice(page, pageSize + page), sort).map(
                                                    (item) => ({
                                                        ...item,
                                                        [SELECTED_FIELD]: selectedState[idGetter(item)],
                                                    })
                                                )}
                                                checkboxElement
                                                // style={{
                                                //     height: queueData.length > 0 ? "100%" : "250px",
                                                // }}
                                                dataItemKey={DATA_ITEM_KEY}
                                                selectedField={SELECTED_FIELD}
                                                skip={page}
                                                take={pageSize}
                                                total={queueData.length}
                                                onPageChange={pageChange}
                                                pageable={{
                                                    pageSizes: [10, 20, 30],
                                                }}
                                                sort={sort}
                                                sortable={true}
                                                onSortChange={(e) => {
                                                    setSort(e.sort);
                                                }}
                                                scrollable={true}
                                            >


                                                <GridColumn
                                                    className="cursor-default"
                                                    field="id"
                                                    title="ID"
                                                    width="100px"
                                                    max-width="30px"
                                                    min-width="100px"
                                                />
                                                <GridColumn
                                                    className="cursor-default"
                                                    field="clinicName"
                                                    title="Clinic Name"
                                                    width="150px"
                                                    max-width="30px"
                                                    min-width="150px"
                                                />
                                                <GridColumn
                                                    className="cursor-default"
                                                    field="s3FileKey"
                                                    title="File"
                                                    width="750px"
                                                />

                                                <GridColumn
                                                    className="cursor-default"
                                                    field="moduleName"
                                                    title="Module Name"
                                                    width="180px"
                                                    max-width="30px"
                                                    min-width="150px"
                                                />
                                                <GridColumn
                                                    className="cursor-default"
                                                    field="status"
                                                    title="Imported"
                                                    width="180px"
                                                    max-width="30px"
                                                    min-width="150px"
                                                />
                                                <GridColumn
                                                    className="cursor-default"
                                                    field="totalRecordsFound"
                                                    title="Found"
                                                    width="180px"
                                                    max-width="30px"
                                                    min-width="150px"
                                                />
                                                <GridColumn
                                                    className="cursor-default"
                                                    field="totalRecordsProcessed"
                                                    title="Processed"
                                                    width="180px"
                                                    max-width="30px"
                                                    min-width="150px"
                                                />
                                                <GridColumn
                                                    title="Action"
                                                    width="100px"
                                                    max-width="30px"
                                                    min-width="100px"
                                                    filterable={false}
                                                    cells={{
                                                        data: (props) => {
                                                            return (
                                                                <td>
                                                                    <div className="row-3">
                                                                        <div className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green m-2">
                                                                            <div className="k-chip-content" onClick={() => requeueFile(props.dataItem)}>
                                                                                <Tooltip anchorElement="target" position="top">
                                                                                    <i className="fas fa-refresh" title="REQUEUE"></i>
                                                                                </Tooltip>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            );
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    <Modal show={show} onHide={handleClose} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>New Data Import</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {
                                <div className="row mt-2">
                                    <div className="col-md-6 edit-Service-popup">
                                        <div className="mb-2">
                                            <DropDownKendoRct
                                                validityStyles={validateError}
                                                label="Region"
                                                onChange={handleChange}
                                                data={region}
                                                value={fields?.regionId}
                                                textField="regionName"
                                                name="regionId"
                                                error={fields?.regionId === "" && errors?.regionId}
                                                required={true}
                                            />
                                        </div>
                                        <div className="mb-2">
                                            <DropDownKendoRct
                                                validityStyles={validateError}
                                                label="Clinic"
                                                onChange={handleChange}
                                                data={clinic}
                                                value={fields?.clinicId}
                                                textField="clinicName"
                                                name="clinicId"
                                                error={fields?.clinicId === "" && errors?.clinicId}
                                                required={true}
                                            />
                                        </div>
                                        <DropDownKendoRct
                                            validityStyles={validateError}
                                            label="Staff"
                                            onChange={handleChange}
                                            data={staff}
                                            value={fields?.staffId}
                                            textField="staffName"
                                            name="staffId"
                                            error={fields?.staffId === "" && errors?.staffId}
                                            required={true}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <InputKendoRct
                                            value={fields?.s3FilePath}
                                            onChange={handleChange}
                                            name="s3FilePath"
                                            label="S3 File Path"
                                            className="form-control"
                                            placeholder={"S3 File Path"}
                                            error={fields?.s3FilePath === "" && errors?.s3FilePath}
                                        />
                                    </div>
                                </div>
                            }
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            <Button variant="primary" onClick={handleAddQueue}>
                                Add to SQS
                            </Button>
                        </Modal.Footer>
                    </Modal>

                </div>
            </div>
        </>
    );
};

export default DataImport;
